import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as firebase from 'firebase';
import queryString from 'query-string';

import styled from 'styled-components';
import Paper from 'material-ui/Paper';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';

import {
  FormTitle,
} from '../Styles/index';
import OrderDetails from './OrderDetails';
import { updateOrder } from '../../actions/orderActions';
import { attachClientData, attachProductData, calculateOrderTotal, formatNumber} from '../../utils/orderService';

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 32px 16px;
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
const SummaryContent = styled.div`
  padding: 0 8px
`
const TextInfo = styled.p`
  line-height: 1.4;
  font-weight: ${props => props.bold ? '600' : '400'};
  font-size: ${props => props.bold ? '18px' : '16px'};
`
const ButtonContainer = styled.div`
  text-align: right;
  padding-top: 16px
`

export const STATUSES = [
  <MenuItem key={'completed'} value={'completed'} primaryText="Completed" />,
  <MenuItem key={'partially-shipped'} value={'partially-shipped'} primaryText="Partially Shipped" />,
  <MenuItem key={'awaiting-fullfilment'} value={'awaiting-fullfilment'} primaryText="Awaiting Fullfilment" />,
  <MenuItem key={'pending'} value={'pending'} primaryText="Pending" />
]

class EditOrder extends Component {
  state = {
    status: 1,
    note: '',
    broadcast: false,
    order: {},
    openSnackBar: false,
    total: 0.0
  }

  _handleSelect = (event, index, value) => {
    this.setState({
      status: value
    });
  }

  _handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value 
    });
  }

  _handleCheck = (event, checked) => {
    this.setState({
      [event.target.name]: checked
    });
  }

  _handleRequestClose = () => {
    this.setState({
      openSnackBar: false,
    });
  };

  _handleSubmit = event => {
    event.preventDefault();
    this.props.updateOrder({ 
      key: this.state.order.key , 
      data: {
        notes: this.state.note,
        status: this.state.status
      }
    }).then(_ => {
      if (this.props.order.status === 'updated') {
        this.setState({
          openSnackBar: true 
        });
      }
    })
  }

  componentDidMount() {
    const parsedQuery = queryString.parse(this.props.location.search);
    const orderId = parsedQuery['order'];
    console.log(orderId)
    firebase.database().ref().child('cart_sessions').child(orderId).on('value', order => {
      console.log(order.val())
      if (!!order.val()) {
        Promise.all([attachClientData({ key: order.key }), attachProductData({ products: order.val().products || {} }) ])
        .then(data => {
          console.log(data[1]);
          this.setState({
            order: {...order.val(), key: order.key, client: data[0].client, products: data[1]},
            status: order.val().status,
            note: order.val().notes,
            total: calculateOrderTotal({ products: data[1]})
          });
        })
      }
    })
  }

  render() {
    return (
      <Container>
        <div>
          <FormTitle>Order Details</FormTitle>
        </div>
        <div style={{height: '64px'}}></div>
        <Paper style={{ maxWidth: '960px', margin: '0 auto', padding: '16px 24px'}} zDepth={1}>
          <form onSubmit={this._handleSubmit}>
            <div>
              <div>
                <TextInfo>Order Date: {(new Date(this.state.order.date)).toDateString()}</TextInfo>
                <TextInfo>Client: {this.state.order.client && this.state.order.client.name}</TextInfo>
                <TextInfo>Number: #{this.state.order.number}</TextInfo>
                <div>
                  <div style={{height: '24px'}}></div>
                  { !this.state.order.active ? <SelectField
                      floatingLabelText="Order Status"
                      value={this.state.status}
                      onChange={this._handleSelect}
                    >
                      {STATUSES.map(status => status)}
                    </SelectField> : <p>This order is active you cannot change the status!</p>
                  }
                </div>
              </div>
              <div style={{height: '64px'}}></div>
              <div>
                <p>Order Details</p>
                <OrderDetails 
                  headers={['Id', 'Product', 'Price', 'Discount', 'Quantity', 'Tvsh', 'Value']} 
                  tableData={this.state.order.products || []}
                />
                <div style={{height: '32px'}}></div>
              </div>
              <FlexContainer>
                <SummaryContent>
                  <TextInfo>Total Amount: { this.state.order.products && 
                    formatNumber(this.state.order.products.reduce((sum, product) => sum + product.client_quantity, 0), true)
                  }</TextInfo>
                  <TextInfo>Tvsh: 0</TextInfo>
                  <TextInfo bold>Subtotal: <span>{ formatNumber(this.state.total)}</span></TextInfo>
                </SummaryContent>
              </FlexContainer>
              <div>
                <TextField
                  fullWidth
                  id="note"
                  name="note"
                  multiLine={true}
                  rows={4}
                  floatingLabelText="Notes"
                  value={this.state.note}
                  onChange={this._handleChange}
                />
                <Checkbox
                  label="Broadcast?"
                  id="broadcast"
                  name="broadcast"
                  checked={this.state.broadcast}
                  onCheck={this._handleCheck}
                />
              </div>
              <ButtonContainer>
                <RaisedButton type='submit' label="Update" primary={true} />
              </ButtonContainer>
            </div>
          </form>
          <div>
            <Snackbar
                open={this.state.openSnackBar}
                message="Order updated successfully!"
                autoHideDuration={3000}
                onRequestClose={this._handleRequestClose}
              />
          </div>
        </Paper>
      </Container>
    );
  }
}

const mapStateToProps = state => ({ order: state.order.updated });
const mapDispatchToProps = { updateOrder };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditOrder));



// WEBPACK FOOTER //
// ./src/components/Orders/EditOrder.js